/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PayrollViewerControllerImportPayroll200ResponseDataInnerWarningsInner } from './payrollViewerControllerImportPayroll200ResponseDataInnerWarningsInner';


export interface PayrollViewerControllerImportPayroll200ResponseDataInner { 
    batchId?: string;
    companyId?: string;
    /**
     * YYYYMM leído del archivo
     */
    period?: string;
    /**
     * FILIAL de TOTVS; un archivo con varias se carga una por filial
     */
    branchCode?: string;
    status?: PayrollViewerControllerImportPayroll200ResponseDataInner.StatusEnum;
    fileName?: string;
    rowCount?: number;
    employeeCount?: number;
    /**
     * Matrículas del archivo que tienen expediente
     */
    employeesMatched?: number;
    weeks?: Array<number>;
    complete?: boolean;
    /**
     * Matrículas con finiquito
     */
    terminated?: Array<string>;
    /**
     * El periodo ya estaba cargado idéntico
     */
    alreadyImported?: boolean;
    /**
     * Cargas de la misma filial que compartían matrículas y quedaron reemplazadas
     */
    supersededBatchIds?: Array<string>;
    /**
     * Conceptos nuevos dados de alta, pendientes de clasificar
     */
    conceptsRegistered?: number;
    warnings?: Array<PayrollViewerControllerImportPayroll200ResponseDataInnerWarningsInner>;
}
export namespace PayrollViewerControllerImportPayroll200ResponseDataInner {
    export type StatusEnum = 'pending' | 'active' | 'superseded' | 'failed';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Active: 'active' as StatusEnum,
        Superseded: 'superseded' as StatusEnum,
        Failed: 'failed' as StatusEnum
    };
}


